import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWeekDays } from "../../../services/teacher";
import { reactToast } from "../../../helper";

export const getWeekDays = createAsyncThunk(
  "weekdays/fetchContent",
  async () => {
    try {
      const { status, data } = await fetchWeekDays();
      if (status === 200) {
        return data?.data;
      } else {
        reactToast("error", data?.message);
      }
    } catch (error) {}
  }
);
